import React from "react";
import { Popup } from "react-map-gl";
import { views } from "../../constants";
import {
  StyledPopup,
  PopupHeader,
  PopupTitle,
  PopupSubtitle,
  PopupContent,
  PopupContentTitle
} from "../Popup/styled";

function SchoolPopup({ className, data, children, isS4sGrant, mapView, ...props }) {
  return (
    <StyledPopup className={className} $mapView={mapView} {...props} as={Popup}>
      <PopupHeader $mapView={mapView}>
        <PopupTitle>{data.title}</PopupTitle>
        <PopupSubtitle>
          {data.subTitle}
          <br />
          {data.city}, {data.state}
        </PopupSubtitle>
      </PopupHeader>
      <PopupContent>
        {mapView === views.S4S_GRANTEES && (
          <PopupContentTitle>Awarded by Solar For Schools Grant Program</PopupContentTitle>
        )}
        <ul>
          {data.systemSize && (
            <li>
              <span>System Size:</span> {data.systemSize}{" "}
              {Number.parseFloat(data.systemSize) ? "kW" : ""}
            </li>
          )}
          {data.estimatedSystemSize && (
            <li>
              <span>Estimated System Size:</span> {data.estimatedSystemSize}{" "}
              {Number.parseFloat(data.estimatedSystemSize) ? "kW" : ""}
            </li>
          )}
          {data.grantAmount && (
            <li>
              <span>Grant Amount:</span> {data.grantAmount}{" "}
            </li>
          )}
          {data.fiscalYear && (
            <li>
              <span>Fiscal Year:</span> {data.fiscalYear}{" "}
            </li>
          )}
          {data.yearInstalled && (
            <li>
              <span>Year Installed:</span> {data.yearInstalled}
            </li>
          )}
          {data.fundingSubtype && (
            <li>
              <span>Funding Type:</span> {data.fundingSubtype}
            </li>
          )}
          {data.structureType && (
            <li>
              <span>Structure Type:</span> {data.structureType}
            </li>
          )}
          {data.cleanEnergyTechnology && (
            <li>
              <span>Clean Energy Technology:</span> {data.cleanEnergyTechnology}
            </li>
          )}
          {/*  <span>Battery Storage:</span> {data.batteryStorage}*/}
        </ul>
        {data.caseStudyURL && (
          <a href={data.caseStudyURL} target="_blank" rel="noreferrer">
            Case Study
          </a>
        )}
      </PopupContent>
    </StyledPopup>
  );
}

export default SchoolPopup;
